import type { OptimizelyDataFile } from '../optimizely.types';
import { rest } from 'msw';

export const generateDatafileHandler = (
    dataFile: OptimizelyDataFile = {
        MOCKED_DATAFILE_RESULT: 'returned by msw'
    }
) => {
    const URL = `${process.env.NEXT_PUBLIC_OPTIMIZELY_URL}/datafiles/${process.env.NEXT_PUBLIC_OPTIMIZELY_KEY}.json`;

    return rest.get<{ data: OptimizelyDataFile }>(URL, (_req, res, ctx) =>
        res(ctx.status(200), ctx.json(dataFile))
    );
};

export const defaultDatafileHandler = generateDatafileHandler();
